<template>
    <div class="one-to-one__section">
        <h2>{{ $t("potential-title") }}</h2>
        <p v-html="$t('potential-legend')"></p>

        <GaussChart
            v-if="gaussianCurve"
            :active-point="activePoint"
            :gaussian-curve="gaussianCurve" />
    </div>
</template>

<script>
// @ is an alias to /src

import Vue from "vue";
import axios from "axios";

import GaussChart from "@/components/charts/GaussChart.vue";

import d3 from "@/utils/d3/d3.js";

export default {
    name: "PotentialChart",
    components: {
        "GaussChart": GaussChart
    },
    props: {
        activePoint: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            gaussianCurve: null,
        };
    },
    computed: {
    },
    watch: {
    },
    mounted: function() {
        this.fetchGaussianCurve();
    },
    methods: {
        fetchGaussianCurve() {

            axios({
                url: "/json/one-to-one/potential-gaussian-curve.json",
            }).then(res => {
                this.gaussianCurve = res.data;
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
    }
};
</script>

